export const IntroDataStructure = [
  {
    image:
      "https://images.ctfassets.net/ooa29xqb8tix/1bYdUtniEAUH3jdqQd3Qc1/7cf21d20882bfe59f01d7bc74e81010d/react-logo.png?w=400&q=50",
    title: "React is JS Framework",
    description:
      "A reaction will be added to Veu very soon. Which will simplify the work style. You will not need to use regular HTML elements.",
  },
  {
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Vue.js_Logo_2.svg/1200px-Vue.js_Logo_2.svg.png",
    title: "Vue is JS Framework",
    description:
      "We are working on Vue. I promise it will be very soon. Vue will be similarly reactive. It will not consist of standard HTML tags.",
  },
]
